import React from "react";
import { AbsoluteFill, Img, interpolate, spring, staticFile, useCurrentFrame, useVideoConfig } from "remotion";
import { loadFont as loadMono } from "@remotion/google-fonts/JetBrainsMono";
import { loadFont as loadText } from "@remotion/google-fonts/Roboto";
import { COLOR, LOGO, perFormatScale } from "../../../brand/theme";

const { fontFamily: mono } = loadMono("normal", { weights: ["500", "700"] });
const { fontFamily: text } = loadText("normal", { weights: ["400", "700"] });

export type VerseCardProps = {
  kicker: string; // серия / тема
  verse: string;
  reference: string; // "Иоанна 3:16 НРП"
};

export const VerseCard: React.FC<VerseCardProps> = ({ kicker, verse, reference }) => {
  const frame = useCurrentFrame();
  const { fps, width, height } = useVideoConfig();
  const k = perFormatScale({ w: width, h: height });
  const enter = spring({ frame, fps, config: { damping: 200 } });
  const rise = interpolate(enter, [0, 1], [30, 0]);
  const op = (a: number, b: number) => interpolate(frame, [a, b], [0, 1], { extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ backgroundColor: COLOR.black, fontFamily: text, justifyContent: "center", alignItems: "center", padding: 110 * k }}>
      <AbsoluteFill style={{ background: `radial-gradient(circle at 80% 12%, ${COLOR.blue}26 0%, transparent 45%)` }} />

      <div style={{ textAlign: "center", maxWidth: width * 0.82, transform: `translateY(${rise}px)` }}>
        <div style={{ opacity: op(0, 18), fontFamily: mono, fontSize: 26 * k, fontWeight: 500, letterSpacing: 6 * k, color: COLOR.blue300, marginBottom: 40 * k }}>
          {kicker.toUpperCase()}
        </div>
        <div style={{ opacity: op(8, 30), color: COLOR.white, fontSize: 60 * k, fontWeight: 700, lineHeight: 1.32 }}>
          {verse}
        </div>
        <div style={{ opacity: op(24, 44), marginTop: 48 * k }}>
          <div style={{ width: 56 * k, height: 4 * k, backgroundColor: COLOR.blue, borderRadius: 2, margin: "0 auto 22px" }} />
          <span style={{ fontFamily: mono, fontSize: 30 * k, fontWeight: 700, color: COLOR.white, letterSpacing: 1 }}>{reference}</span>
        </div>
      </div>

      <Img src={staticFile(LOGO.markAsset)} style={{ position: "absolute", bottom: 64 * k, left: "50%", marginLeft: -34 * k, width: 68 * k, height: 68 * k, opacity: op(16, 40) * 0.85, filter: LOGO.whiteOnDarkFilter }} />
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
